module.exports = __webpack_public_path__ + "img/RKS-PLUS-front.ad33fd38.jpg";